var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isOpen
    ? _c("modal", {
        staticClass: "modal-wrapper",
        attrs: { width: _vm.width, height: _vm.height },
        on: {
          "hide-modal": function ($event) {
            return _vm.hideModal()
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "inquire-wrapper" },
                    [
                      _c(
                        "h3",
                        {
                          staticClass: "text-center bold",
                          attrs: { id: "modal-title" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.confirmation
                                ? "Thank you!"
                                : `Inquire about ${
                                    _vm.activeProductInfo
                                      ? _vm.activeProductInfo.name
                                      : _vm.productName
                                  }`
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _vm.confirmation
                        ? _c("div", { staticClass: "confirmation" }, [
                            _c("p", [
                              _vm._v(
                                "We've received your message. A dedicated sales team member will get back to you within 24 hours."
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "If you have any further questions, feel free to reach out to " +
                                  _vm._s(_vm.ownerEmail) +
                                  "."
                              ),
                            ]),
                          ])
                        : _c("div", { staticClass: "inputs-wrapper" }, [
                            _vm.isVGBasicCustomer
                              ? _c("div", { staticClass: "input-wrapper" }, [
                                  _vm._v(
                                    "\n                    Your business does not currently leverage the full Vehicle Gateway functionality. Please contact your sales rep to upgrade or add-on to your fleet.\n                "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-wrapper" }, [
                              _c("label", { attrs: { for: "message" } }, [
                                _vm._v("Your message "),
                                _c("span", { staticClass: "text-red-700" }, [
                                  _vm._v("*"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("textarea", {
                                attrs: { name: "message", type: "text" },
                                domProps: { value: _vm.message },
                                on: {
                                  change: function ($event) {
                                    return _vm.keyUpHandler($event, "message")
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-wrapper" }, [
                              _c("label", { attrs: { for: "fullName" } }, [
                                _vm._v("Full name (First and Last name)"),
                                _c("span", { staticClass: "text-red-700" }, [
                                  _vm._v("*"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                attrs: { type: "text", name: "fullName" },
                                domProps: { value: _vm.fullName },
                                on: {
                                  change: function ($event) {
                                    return _vm.keyUpHandler($event, "fullName")
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-wrapper" }, [
                              _c("label", { attrs: { for: "email" } }, [
                                _vm._v("Email "),
                                _c("span", { staticClass: "text-red-700" }, [
                                  _vm._v("*"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                attrs: { type: "text", name: "email" },
                                domProps: { value: _vm.email },
                                on: {
                                  change: function ($event) {
                                    return _vm.keyUpHandler($event, "email")
                                  },
                                },
                              }),
                            ]),
                          ]),
                      _vm._v(" "),
                      _vm.error !== ""
                        ? _c(
                            "p",
                            { staticClass: "text-xl text-red-700 text-center" },
                            [_vm._v(_vm._s(_vm.error))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-button", {
                        attrs: {
                          position: "center",
                          mobile: "11",
                          tablet: "9",
                          desktop: "9",
                          styling: "primary rounded-full text-base",
                          textAlign: "center",
                          disabled: false,
                        },
                        on: {
                          onClickEvent: function ($event) {
                            _vm.confirmation
                              ? _vm.hideModal()
                              : _vm.productInquiryRequestHandler()
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "content",
                              fn: function () {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.confirmation ? "Close" : "Submit"
                                        ) +
                                        "\n                    "
                                    ),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1822988970
                        ),
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          1875675693
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }